import React from 'react';
import { twMerge } from 'tailwind-merge';

import Duration from '../Duration';

interface Props {
  shouldShowDuration: boolean;
  title: string;
  previewUrl: string;
  duration?: number;
  isCollection?: boolean;
  thumbnailUrl?: string;
  linkUrl: string;
}

const MediaGridVideo = ({
  shouldShowDuration,
  title,
  previewUrl,
  duration,
  isCollection,
  thumbnailUrl,
  linkUrl,
}: Props) => {
  const videoRef = React.createRef<HTMLVideoElement>();

  const playOnMouseOver = () => {
    const { current: ref } = videoRef;
    if (ref && ref.play) {
      ref.play();
    }
  };

  const pauseOnMouseOut = () => {
    const { current: ref } = videoRef;
    if (ref && ref.pause) {
      ref.pause();
      ref.currentTime = 0;
    }
  };

  return (
    <React.Fragment>
      {shouldShowDuration && (
        <div className="contentItemVideoTextContainer">
          <span className="contentItemVideoTextContainer-title">{title}</span>
          <Duration seconds={duration} />
        </div>
      )}
      <a
        className="mediaGridContent-contentItemLink"
        href={linkUrl}
        onMouseOver={playOnMouseOver}
        onFocus={playOnMouseOver}
        onMouseOut={pauseOnMouseOut}
        onBlur={pauseOnMouseOut}
      >
        <video
          className={twMerge(
            'mediaGridContent-contentItemBackgroundVideo',
            isCollection && 'isCollection'
          )}
          key={`video-${title}`}
          id={`mediaGridContent-contentItemBackgroundVideo-${title}`}
          poster={thumbnailUrl}
          loop
          muted
          controls={false}
          preload="false"
          ref={videoRef}
        >
          <source type="video/mp4" src={previewUrl} />
        </video>
      </a>
    </React.Fragment>
  );
};

export default MediaGridVideo;
